var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCargoicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6V18H24V6H1ZM3.03256 7.24324H3.99535V16.7568H3.03256V7.24324ZM5.6 7.24324H6.56279V16.7568H5.6V7.24324ZM8.16744 7.24324H9.13023V16.7568H8.16744V7.24324ZM10.7349 7.24324H11.6977V16.7568H10.7349V7.24324ZM13.3023 7.24324H14.2651V16.7568H13.3023V7.24324ZM15.8698 7.24324H16.8326V16.7568H15.8698V7.24324ZM18.4372 7.24324H19.4V16.7568H18.4372V7.24324ZM21.0047 7.24324H21.9674V16.7568H21.0047V7.24324Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCargoicon);
export default __webpack_public_path__ + "static/media/cargo.icon.6e1e80536ded074d107ab911f7157b07.svg";
export { ForwardRef as ReactComponent };